import { AppData, Lightning, Log, Pin } from '@lightningjs/sdk'
import ProfileScreen from './profile-screen';
import LoginScreen from './login';
import Router from '@lightningjs/sdk/src/Router';
import GetCodeFacebook from './get-code-facebook';
import CreatePinScreen from './create-pin';
import ValidatePinScreen from './verify-pin';
import { AppSetup } from '../../lib/app-setup';
import GetProfileScreen from './get-profile';
import GetCodeGoogle from './get-code-google';

export interface ParentalControlTemplateSpec extends Lightning.Component.TemplateSpecLoose {
    page: any
}

export default class ParentalControlWidget extends Lightning.Component {

    page: any
    // _currentPage = 'profile'
    static override _template() {
        return {
            
        }
    }


    override _getFocused() {
        return this.tag('Content')!
    }

    override _onActivated(page: any) {
        Log.info('Parental:  _onActivated', page)
        this.page = page
    }

    override _focus() {
        Log.info('Parental: Control focus isset')
        this.visible = true
    }

    override _unfocus() {
        Log.info('Parental: Control unfocused')
        this.visible = false
    }

    showProfile(isSuccess = false) {
        Log.info('showProfile: ', isSuccess)
        this.patch({
            Content: undefined
        })
        setTimeout(() => {
            this.patch({
                w: 1920,
                h: 1080,
                rect: true,
                collision: true,
                color: 0x99000000,
                flex: { direction: 'column', alignItems: 'center', justifyContent: 'center' },
                Content: {
                    collision: true,
                    type: ProfileScreen,
                    isSuccess: isSuccess,
                    signals: {
                        'login': this._showLogin.bind(this),
                        'verifyPin': this._showVerifyPin.bind(this),
                        'reloadApp': this._handleReloadApp.bind(this),
                        'back': this._handleBack.bind(this)
                    }
                }
            })
        }, 0)
        Router.focusWidget('ParentalControl')
    }

    _handleReloadApp(acontent) {
        const { appState } = AppData as AppSetup
        const app = appState?.getApp()
        this._handleBack()
        app?.reloadAppOnParentalControlChange(acontent)
    }

    _showLogin() {
        this.patch({
            Content: undefined
        })
        setTimeout(() => {
            this.patch({
                Content: {
                    w: 1000,
                    h: 400,
                    type: LoginScreen,
                    collision:true,
                    signals: {
                        'codeScreen': this._showCodeScreen.bind(this),
                        'back': this.showProfile.bind(this)
                    }
                }
            })
        }, 0)
    }

    _showCodeScreen() {
        Log.info('_showCodeScreen')
        this.patch({
            Content: undefined
        })
        setTimeout(() => {
            this.patch({
                Content: {
                    w: 1000,
                    h: 400,
                    type: GetCodeGoogle,
                    collision: true,
                    signals: {
                        'createPin': this._showCreatePin.bind(this),
                        'back': this.showProfile.bind(this)
                    }
                }
            })
        }, 0)
    }

    _showCreatePin() {
        Log.info('_showCreatePin')
        this.patch({
            Content: undefined
        })
        setTimeout(() => {
            this.patch({
                Content: {
                    w: 1920,
                    h: 1080,
                    color: 0x99000000,
                    flex: { direction: 'column', alignItems: 'center', justifyContent: 'center' },
                    type: CreatePinScreen,
                    signals: {
                        'profile': this.showProfile.bind(this),
                        'back': this.showProfile.bind(this)
                    }
                }
            })
        }, 0)
    }

    _showVerifyPin() {
        Log.info('_showValidatePin')
        this.patch({
            Content: undefined
        })
        setTimeout(() => {
            this.patch({
                Content: {
                    w: 1000,
                    h: 400,
                    type: ValidatePinScreen,
                    collision: true,
                    signals: {
                        'profile': this.showProfile.bind(this),
                        'login': this._showLogin.bind(this),
                        'back': this.showProfile.bind(this)
                    }
                }
            })
        }, 0)
    }

    override _handleKey(e: KeyboardEvent): boolean | void {
        return true
    }

    override _handleBack(e: KeyboardEvent): boolean | void {
        this.patch({
            w: 0,
            h: 0,
            rect: true,
            collision: false,
            color: 0x99000000,
            flex: { direction: 'column', alignItems: 'center', justifyContent: 'center' },
            Content: undefined
        })
        Router.focusPage()
        return true
    }

    _handleClick(target, position) {
       Log.info('Parental:  _handleClick', target.ref, position)
    }
}